<template>
    <div class="container">
        <div class="level">
            <div class="level-item level-left">
                <b-button type="is-dark" @click="goTo('create')">Create New Domain</b-button>
            </div>
        </div>
        <div class="card">
            <div class="card-content">
                <b-table :data="domains">
                    <template slot-scope="props">
                        <b-table-column
                            field="id"
                            label="ID"
                        >
                            {{props.row.id}}
                        </b-table-column>
                        <b-table-column
                            field="display_name"
                            label="Display Name"
                        >
                            {{props.row.attributes.display_name}}
                        </b-table-column>
                        <b-table-column
                            field="value"
                            label="Value"
                        >
                            {{props.row.attributes.value}}
                        </b-table-column>
                        <b-table-column
                            field="actions"
                            label="Actions"
                        >
                            <b-button type="is-primary" size="is-small" @click="goTo('domain.edit',{id:props.row.id})">Edit</b-button>
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export default {
    data(){
        return {
            domains:[]
        }
    },
    async mounted(){
        await this.getDomains()
    },
    methods:{
        async getDomains(){
            return Vue.$tagService.getList().then((response)=>{
                this.domains = response.data
            })
        },
        goTo(name,params){
            if(name==='create'){
                this.$router.push({
                    name:'domain.create'
                })
            }else{
                this.$router.push({
                    name:'domain.edit',
                    params:params
                })
            }
        }
    }
}
</script>